export default "__VITE_ASSET__BODjoKL0__"